"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Line = void 0;
var react_1 = __importDefault(require("react"));
var structure_1 = require("remota-client/component/structure");
var form_1 = require("remota-client/component/form");
var button_1 = require("remota-client/component/button");
var util_1 = require("remota-common/util");
var Line = function (props) {
    var column = props.column, onChange = props.onChange, onDelete = props.onDelete, fields = props.fields;
    var handleSelectChange = react_1.default.useCallback(function (e) {
        var _a;
        onChange(__assign(__assign({}, column), (_a = {}, _a[e.target.name] = e.target.value, _a)));
    }, [column, onChange]);
    var handleInputChange = react_1.default.useCallback(function (e) {
        var _a;
        onChange(__assign(__assign({}, column), (_a = {}, _a[e.target.name] = e.target.value, _a)));
    }, [column, onChange]);
    var handleDelete = react_1.default.useCallback(function () {
        onDelete();
    }, [onDelete]);
    return (react_1.default.createElement(structure_1.FormRowStructure, null,
        react_1.default.createElement(structure_1.FormCellStructure, { flex: "4 0" },
            react_1.default.createElement(structure_1.FormLineStructure, { label: "Remota" },
                react_1.default.createElement(structure_1.FormCellLabel, null,
                    react_1.default.createElement(form_1.BoxSelect, { name: "remotaKey", value: column.remotaKey, onChange: handleSelectChange },
                        react_1.default.createElement("option", { value: "" }, "\u9078\u629E\u3059\u308B"),
                        fields.concat([util_1.HYPER_PASTE_CSV_DEPARTMENT_FIELD]).map(function (field) { return (react_1.default.createElement("option", { key: field.key, value: field.key }, field.name)); }))))),
        react_1.default.createElement(structure_1.FormCellStructure, { flex: "4 0" },
            react_1.default.createElement(structure_1.FormLineStructure, { label: "CSV" },
                react_1.default.createElement(structure_1.FormCellLabel, null,
                    react_1.default.createElement(form_1.BoxInput, { name: "externalKey", value: column.externalKey, onChange: handleInputChange })))),
        react_1.default.createElement(structure_1.FormCellStructure, { flex: "2 0" },
            react_1.default.createElement(structure_1.FormLineStructure, { label: "\u524A\u9664" },
                react_1.default.createElement(structure_1.FormCellLabel, null,
                    react_1.default.createElement(button_1.NormalButton, { onClick: handleDelete }, "\u524A\u9664"))))));
};
exports.Line = Line;
